import Banner from '../components/Banner';
import Footer from '../components/Footer';
import Register from '../components/Register';
import '../styles/Login.css';

const Acceso: React.FC = () => {
  return (
    <div className="page-container">
      <Banner />
      <main className="login-main">
        <Register />
      </main>
      <Footer />
    </div>
  );
};

export default Acceso;
